<template>
  <div :class="showFileList ? 'a-upload-file' : 'a-upload-file hide-file-list'">
    <el-upload :action="action" :list-type="listType" :auto-upload="autoUpload" :limit="Number(limit)" :file-list="list" :showFileList="multiple && showFileList" :http-request="change"
      :on-change="change" :on-remove="remove">
      <el-button :size="buttonSize" :loading="loading" :disabled="disabled">{{text}}</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'AuploadFile',
  props: {
    src: null,
    url: { type: String, default: () => '' },
    text: { type: String, default: () => '导入' },
    type: { type: String, default: () => 'excel' },
    action: { type: String, default: () => '#' },
    multiple: { type: Boolean, default: () => false },
    size: { type: String, default: () => '2m' },
    buttonSize: { type: String, default: () => 'small' },
    listType: { type: String, default: () => '' },
    autoUpload: { type: Boolean, default: () => false },
    fileList: { type: Array, default: () => [] },
    showFileList: { type: Boolean, default: () => false },
    limit: { type: String, default: () => '10' },
    removeMark: { type: String, default: () => 'will-remove' },
    disabled: { type: Boolean, default: () => false },
  },
  data() {
    return {
      list: [],
      link: '',
      defaultUrl: null,
      loading: false,
    }
  },
  watch: {
    src() {
      this.update();
    },
    link() {
      this.update();
    }
  },
  created() {
    this.create();
    this.update();
  },
  methods: {
    create() {
      if (this.multiple) {
        this.list = this.fileList.concat(this.list);
      } else {
        this.defaultUrl = this.src;
      }
    },
    update() {
      if (this.multiple) {
        this.list = this.fileList.concat(this.list);
      } else {
        if (this.src && this.src.url && !this.src.url.includes(this.removeMark) || this.src && !this.src.includes(this.removeMark)) {
          this.link = this.src && this.src.url || this.src;
        }
      }
    },
    change(file = {}, list = []) {
      if (this.multiple) {
        this.$emit('change', list);
      } else {
        if ((file.size / 1024) > (parseInt(this.size) * 1024)) {
          this.$message.info(`上传文件超过了${this.size}限制`);
          return false;
        } else {
          if (this.type == 'excel') {
            const { raw } = file;
            this.$emit('change', raw);
          } else {
            if (file && file.url) {
              const { url, raw } = file;
              this.link = url;
              const params = Object.assign(raw, { url, old: this.removeMark + '=' + this.defaultUrl });
              this.$nextTick(() => {
                this.$emit('input', params);
                this.$nextTick(() => this.$emit('change', params));
              });
            }
          }
        }
      }
    },
    remove() {
      this.$emit('remove');
      this.$nextTick(() => {
        this.$emit('input', this.removeMark + '=' + this.defaultUrl);
        this.$nextTick(() => this.link = '');
      });
    },
  },
}
</script>

<style scoped>
@import "index.css";
</style>